import httpHelper from "@/helpers/httpHelper";
// action types
export const REGISTER = "Register"; 

//mutation types
export const SET_USER = "setUser";

export default {
    state: {
        
        user:null,
        
    },
    getters: {
        /**
         * loade list of Gateway
         * @param state
         * @returns {*}
         */
        loadedUser(state) {
            return state.user;
        },
    },
    actions: {
       
        
        /**
         * Set the create listCheckout
         * @param state
         * @param payload
         */
         [REGISTER](context,payload) {
            
            return new Promise((resolve, reject) => {
            httpHelper
                .postData('users',payload)
                .then((response) => {
                    if (response.success) {
                    context.commit(SET_USER,response.result)
                    }
                    resolve(response)
                }).catch((error) => {
                    reject(error)
                })
            });
        },
    },
    mutations: {
       
        [SET_USER](state, payload) {
            state.user = payload
        }
    }
};